import { Injectable } from '@angular/core';

@Injectable()
export abstract class LocalAppLauncherService {

    public abstract async launchOfficeApp(appName: string, filePath?: string, preLaunchCallback?: () => void, isExcelCreateNew?: boolean): Promise<boolean>;

    public abstract async launchOfficeAppWithTemplate(appName: string, templateUrl: string): Promise<boolean>;

    public abstract async openPathInExplorer(path: string): Promise<void>;

    public abstract async shouldOpenInOfficeApp(appName: string): Promise<boolean>;
}
